import { CheckItemRecord } from "./CheckItemRecord";
import { MenuItemRecord } from "./MenuItemRecord";
import { ReportGroupSummaries } from "./ReportGroupSummaries";
import { Store } from "./Store";
import { SuperGroup } from "./SuperGroup";

export class ReportGroup {
	venueKey: number;
	ID: number;
	Name: string;
	SuperGroupID: number;
	NonSales: string;
	NS: boolean;

	CheckItemRecords: CheckItemRecord[];

	ReportGroupSummaries: ReportGroupSummaries[];

	MenuItemRecords: MenuItemRecord[];

	SuperGroup: SuperGroup;

	stores: Store;

	public constructor(init?: Partial<ReportGroup>) {
		Object.assign(this, init);
	}
}
